import * as React from 'react';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';

interface CorrectionMetadataProps {
    principalInvestigator: string;
    site: string;
    country: string;
    subject: string;
    visit: string;
    session: string;
    sessionDate: string | React.JSX.Element;
}

export const CorrectionMetadata = (props: CorrectionMetadataProps) => {
    const { fieldDisplayText } = useCurrentStudyConfigurationContext();

    const subjectIdDisplayText = fieldDisplayText.SubjectId;
    
    const metadata = [
        { Title: 'Site', Content: props.site, SubItem: { Title: 'Site Country', Content: props.country } },
        { Title: 'Principal Investigator', Content: props.principalInvestigator },
        { Title: subjectIdDisplayText, Content: props.subject },
        { Title: 'Visit', Content: props.visit },
        { Title: 'Session', Content: props.session, SubItem: { Title: 'Session Date', Content: props.sessionDate } },
    ]

    return (
        <>
            {metadata.map(x => {
                return (
                    <React.Fragment key={`Metadata${x.Title}`}>
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>{x.Title}</h4>
                            </div>
                            <div className="col-sm-6 pull-right" style={{ overflow: "auto" }}>
                                {x.Content}
                            </div>
                        </div>
                        {x.SubItem && (
                            <div className="row">
                                <div className="col-sm-6">
                                    <h4>{x.SubItem.Title}</h4>
                                </div>
                                <div className="col-sm-6 pull-right">
                                    {x.SubItem.Content}
                                </div>
                            </div>
                        )}
                        <hr />
                    </React.Fragment>
                );
            })}
        </>
    )
}
